var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _path4, _linearGradient4, _path5, _path6, _path7, _path8, _linearGradient5, _path9, _path10, _linearGradient6, _path11, _path12, _path13, _path14, _path15, _linearGradient7, _path16, _path17, _path18, _path19, _path20, _linearGradient8, _path21, _path22, _path23, _linearGradient9, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationModified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 794,
    height: 1050,
    viewBox: "0 0 794 1050",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1",
    x1: 452.4606,
    y1: 21.3226,
    x2: 288.6685,
    y2: 305.2673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "url(#linearGradient1)",
    stroke: "none",
    opacity: 0.4,
    d: "M 394.799988 300.599976 C 386.299988 295.700012 380.200012 295.599976 376.5 300.200012 C 372.700012 304.799988 370.899994 312.599976 370.899994 323.5 L 370.899994 382.5 C 370.899994 393.700012 369.899994 403 367.799988 410.400024 C 365.700012 418.099976 362.200012 423.5 357.399994 426.700012 C 352.700012 430 346.299988 430.799988 338.200012 429.299988 C 330.299988 427.900024 320.399994 423.700012 308.600006 416.900024 L 303 413.599976 L 303 367.099976 L 310.100006 371.200012 C 318.600006 376.099976 324.200012 376.700012 327 373.200012 C 330 369.700012 331.5 362.5 331.5 351.599976 L 331.5 299.599976 C 331.5 286 332.799988 275.299988 335.5 267.5 C 338.100006 259.599976 343.399994 254.599976 351.299988 252.400024 C 343.399994 241.099976 338.100006 229.900024 335.5 219 C 332.899994 208.099976 331.600006 195.900024 331.600006 182.299988 L 331.600006 130.299988 C 331.600006 119.400024 330.100006 110.400024 327.100006 103.5 C 324.299988 96.700012 318.600006 90.799988 310.200012 85.900024 L 303.100006 81.799988 L 303.100006 35.299988 L 308.700012 38.599976 C 320.5 45.400024 330.399994 52.700012 338.299988 60.400024 C 346.399994 68.200012 352.799988 76.400024 357.5 85.200012 C 362.399994 94 365.899994 103.400024 367.899994 113.5 C 370 123.299988 371 133.799988 371 145 L 371 204 C 371 214.900024 372.899994 224.900024 376.600006 233.799988 C 380.399994 242.700012 386.5 249.700012 394.899994 254.5 L 394.799988 300.599976 Z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2",
    x1: 357.8021,
    y1: 2.0143,
    x2: 193.9457,
    y2: 286.0023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "url(#linearGradient2)",
    stroke: "none",
    opacity: 0.4,
    d: "M 180.600006 129.700012 C 189.100006 134.599976 195.199997 134.700012 198.899994 130.099976 C 202.699997 125.5 204.5 117.700012 204.5 106.799988 L 204.5 47.799988 C 204.5 36.599976 205.5 27.299988 207.600006 19.900024 C 209.699997 12.199951 213.100006 6.800049 217.800003 3.5 C 222.699997 0.300049 229.100006 -0.5 237 0.900024 C 245.100006 2.400024 255.100006 6.599976 266.899994 13.5 L 272.5 16.800049 L 272.5 63.299988 L 265.399994 59.200012 C 256.899994 54.299988 251.199997 53.599976 248.199997 57.099976 C 245.399994 60.700012 244 67.900024 244 78.900024 L 244 130.900024 C 244 144.400024 242.699997 155.200012 240 163 C 237.399994 170.900024 232.100006 175.900024 224.199997 178.099976 C 232.100006 189.400024 237.399994 200.599976 240 211.5 C 242.600006 222.400024 243.899994 234.599976 243.899994 248.200012 L 243.899994 300.200012 C 243.899994 311.099976 245.300003 320 248.100006 326.900024 C 251.100006 333.799988 256.799988 339.799988 265.299988 344.599976 L 272.399994 348.700012 L 272.399994 395.200012 L 266.799988 391.900024 C 255 385.099976 245 377.700012 236.899994 370 C 229 362.299988 222.600006 354.099976 217.699997 345.200012 C 213 336.5 209.600006 327.099976 207.600006 317.099976 C 205.5 307.299988 204.5 296.799988 204.5 285.599976 L 204.5 226.599976 C 204.5 215.700012 202.600006 205.700012 198.899994 196.799988 C 195.100006 187.900024 189 180.900024 180.600006 176.099976 L 180.600006 129.700012 Z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3",
    x1: 638.7835,
    y1: 137.2459,
    x2: 436.9284,
    y2: 486.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "url(#linearGradient3)",
    stroke: "none",
    opacity: 0.15,
    d: "M 423.700012 13.099976 L 634.799988 135 L 634.700012 641.099976 L 423.600006 519.299988 L 423.700012 13.099976 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path3",
    fill: "#ce8a65",
    stroke: "none",
    d: "M 384 79.400024 L 552 176.299988 L 552 222.799988 L 384 125.900024 L 384 79.400024 Z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4",
    x1: 561.2605,
    y1: 358.2282,
    x2: 505.1585,
    y2: 455.4231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path4",
    fill: "url(#linearGradient4)",
    stroke: "none",
    opacity: 0.2,
    d: "M 451.200012 294.700012 L 610.400024 386.599976 L 610.400024 527.299988 L 451.200012 435.400024 L 451.200012 294.700012 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 449.600006 186.799988 L 611.200012 280.099976 L 611.200012 296 L 449.600006 202.700012 L 449.600006 186.799988 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path6",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 449.600006 218.799988 L 589.299988 299.400024 L 589.299988 315.299988 L 449.600006 234.700012 L 449.600006 218.799988 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 449.600006 250.400024 L 568.200012 318.799988 L 568.200012 334.700012 L 449.600006 266.299988 L 449.600006 250.400024 Z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5",
    x1: 496.0542,
    y1: 14.1601,
    x2: 560.4191,
    y2: 196.3852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    fill: "url(#linearGradient5)",
    stroke: "none",
    opacity: 0.2,
    d: "M 423.700012 13.099976 L 634.799988 135 L 634.799988 202.799988 L 423.600006 81 L 423.700012 13.099976 Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.2,
    d: "M 476.399994 77.900024 C 476.399994 88.200012 470.399994 93 463 88.700012 C 455.600006 84.400024 449.600006 72.700012 449.600006 62.400024 C 449.600006 52.099976 455.600006 47.299988 463 51.599976 C 470.399994 55.900024 476.399994 67.700012 476.399994 77.900024 Z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6",
    x1: 477.7794,
    y1: 418.821,
    x2: 370.8604,
    y2: 604.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path10",
    fill: "url(#linearGradient6)",
    stroke: "none",
    opacity: 0.15,
    d: "M 43.299999 168.099976 L 693.099976 543.099976 L 693 1049.5 L 43.200001 674.5 L 43.299999 168.099976 Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fill: "#ce8a65",
    stroke: "none",
    d: "M 0.2 292.900024 L 168.100006 389.799988 L 168.100006 436.299988 L 0.2 339.5 L 0.2 292.900024 Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path12",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 87.099998 420.700012 L 459.899994 635.900024 L 459.899994 651.799988 L 87.099998 436.599976 L 87.099998 420.700012 Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 87.099998 452.700012 L 408.700012 638.299988 L 408.700012 654.200012 L 87.099998 468.599976 L 87.099998 452.700012 Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path14",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 87.099998 484.400024 L 360.799988 642.400024 L 360.799988 658.299988 L 87.099998 500.299988 L 87.099998 484.400024 Z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7",
    x1: 533.0603,
    y1: 798.178,
    x2: 476.9583,
    y2: 895.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fill: "url(#linearGradient7)",
    stroke: "none",
    opacity: 0.2,
    d: "M 338.700012 686 L 666.5 875.200012 L 666.5 1015.900024 L 338.700012 826.700012 L 338.700012 686 Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path16",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 363.399994 728.099976 L 412.799988 756.599976 L 412.799988 803.099976 L 363.399994 774.599976 L 363.399994 728.099976 Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 423.899994 765.299988 L 473.299988 793.799988 L 473.299988 840.299988 L 423.899994 811.799988 L 423.899994 765.299988 Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path18",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 484.700012 799.799988 L 534.099976 828.299988 L 534.099976 874.799988 L 484.700012 846.299988 L 484.700012 799.799988 Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 545.5 836.5 L 594.900024 865 L 594.900024 911.5 L 545.5 883 L 545.5 836.5 Z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8",
    x1: 193.0128,
    y1: 596.5237,
    x2: 136.9108,
    y2: 693.7197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path20",
    fill: "url(#linearGradient8)",
    stroke: "none",
    opacity: 0.2,
    d: "M 26.1 500.200012 L 299 657.700012 L 299 798.400024 L 26.1 640.799988 L 26.1 500.200012 Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path21",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 53.599998 552.099976 L 270.399994 677.200012 L 270.399994 693.099976 L 53.599998 568 L 53.599998 552.099976 Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path22",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.15,
    d: "M 53.599998 584.099976 L 227.199997 684.299988 L 227.199997 700.200012 L 53.599998 599.900024 L 53.599998 584.099976 Z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient9",
    x1: 204.2805,
    y1: 112.8418,
    x2: 450.6736,
    y2: 530.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path23",
    fill: "url(#linearGradient9)",
    stroke: "none",
    opacity: 0.2,
    d: "M 43.299999 168.099976 L 692.200012 542.700012 L 692.200012 611.299988 L 43.299999 236.799988 L 43.299999 168.099976 Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path24",
    fill: "#ffffff",
    stroke: "none",
    opacity: 0.2,
    d: "M 114 243.200012 C 114 253.5 108 258.299988 100.599998 254 C 93.199997 249.700012 87.199997 238 87.199997 227.700012 C 87.199997 217.400024 93.199997 212.599976 100.599998 216.900024 C 108 221.200012 114 233 114 243.200012 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationModified);
export default __webpack_public_path__ + "static/media/Illustration_modified.ea0df075c189e2e5db91dde855cd75ec.svg";
export { ForwardRef as ReactComponent };